<div class="container" fxLayout="column">
    <div fxLayout="row" fxLayoutGap="5vw" fxGrow="1" fxLayoutAlign="center space-around">
        <div fxFlex class="logo" fxLayoutAlign="center center">
            <img src="../../../assets/images/logo.png" class="circle z-depth-2 responsive-img activator">
        </div>
        <div fxFlex fxLayoutAlign="start center ttt" class="form-container">
            <form fxLayout="column" fxLayoutGap="4vh">
                <!-- <h1 class="title" fxFlex>{{'LOGIN' | translate}}</h1> -->
                <div fxFlex fxLayout="column" fxLayoutGap="2vh" fxLayout.lt-md="column">
                    <div fxFlex class="input" fxLayout="row" >
                        <span fxFlex fxGrow="0">
                            <mat-icon style="margin-top: 3px;">domain</mat-icon>
                        </span>
                        <mat-select 
                            (selectionChange)="setOrganization($event.value)" [(value)]="organization">
                            <mat-option *ngFor="let org of orgList" [value]="org">
                            {{ org.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>